export default __webpack_public_path__ + "static/media/TMSPortal2.768f50bc.png";